import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";

import Checkbox from "../../Form/Checkbox";

export const CheckBoxAccess = styled(Checkbox, {
  shouldForwardProp: (props) => props !== "hasError",
})(({ hasError }: { hasError: boolean }) => ({
  "& span:nth-child(2) > span": {
    fontWeight: 500,
    color: hasError ? "#D92D20" : "#465869",
  },
}));

const styles = makeStyles((theme: Theme) => ({
  accessTitle: {
    color: "#465869",
    fontSize: "20px",
    fontFamily: "Manrope",
    fontWeight: 600,
    lineHeight: "24px",
    marginRight: "15px",
  },
  mainDiv: {
    border: "1px solid #93A9BD",
    backgroundColor: "#F8FAFC",
    padding: "0px 12px 12px",
  },
  modal: {
    width: "35vw",
    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  paper: {
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    width: "35vw",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],

    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  modalBody: {
    height: "100%",
    width: "100%",
    padding: "0 16px 19px",
    "@media (min-height: 750px)": {
      overflowX: "hidden",
    },
    [theme.breakpoints.down("md")]: {
      overflowY: "scroll",
      overflowX: "hidden",
    },
    [theme.breakpoints.down("sm")]: {
      overflowY: "scroll",
      overflowX: "hidden",
      paddingRight: ".55rem",
    },
    "& textarea": {
      resize: "none",
    },
  },
  containerTitle: {
    marginBottom: "21px",
  },
  header: {
    borderBottom: "1px solid #20639D",
    backgroundColor: "#308CDB",
    padding: "6px 9px",
    marginBottom: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& > h2": {
      fontSize: "16px",
      fontWeight: "bold",
      color: "#fff",
      lineHeight: "24px",
    },
    "& > button": {
      padding: ".2rem",
      color: "#fff",
    },
  },
  instructionListLabel: {
    color: "#465869",
    fontSize: "14px",
    fontWeight: "bold",
    lineHeight: "18px",
  },
  typeOfInstructionLabel: {
    color: "#465869",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "18px",
    marginBottom: "8px",
    fontFamily: "Manrope",
  },
  instructionList: {
    listStyle: "none",
    paddingLeft: "29px",
    "& li": {
      "& p": {
        color: "#465869",
        fontSize: "12px",
      },
      "& span": {
        color: "#9ca6af",
        fontSize: "12px",
      },
    },
  },
  radioLabel: {
    "& span:nth-child(2)": {
      fontWeight: "normal",
      color: "#308CDB",
    },
  },
  iconButton: {
    "& span": {
      "& svg": {
        color: "#CF4842",
      },
    },
  },
  buttonAddSpecialInstruction: {
    marginLeft: "15px",
  },
  modalFooter: {
    marginTop: 24,
    display: "flex",
    alignItems: "center",
    gap: 5,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  topReverseSpace: {
    marginTop: "-8px",
  },
  rightSpace: {
    "& div": {
      marginRight: "10px",
    },
  },
}));

export default styles;
